export enum ALERT_TYPES {
  BROKEN_LINK = 'BROKEN_LINK',
}

export enum ALERT_STATUSES {
  OPEN = 'OPEN',
  IN_PROGRESS = 'IN_PROGRESS',
  RESOLVED = 'RESOLVED',
  CANCELLED = 'CANCELLED',
}

export enum ALERT_RESOURCE_TYPES {
  SEQUENCE = 'SEQUENCE',
  LEARNING_RESOURCE = 'LEARNING_RESOURCE',
}

/** Mongoose model metadata owned by the alerts bounded context. */
export const ALERT_MODEL = {
  MODEL_NAME: 'Alert',
  COLLECTION_NAME: 'Alerts',
} as const;

/** Mongoose model name of the User aggregate referenced by alerts. */
export const USER_MODEL_NAME = 'User';

/** Mongoose model name of the Lesson aggregate referenced by alerts. */
export const LESSON_MODEL_NAME = 'Lesson';
export * from './error-codes';
